import React from 'react';
import Header from '../../views/Header';
import AboutMeHeader from './AboutMeHeader';
import AboutMeRightHeader from './AboutMeRightHeader';
import Footer from '../../views/Footer';

function PortfolioHome(props) {
    return (
        <div>
        <Header/>
      <header className="App-header">
        <AboutMeHeader title='Prakash kumar Tiwari'
        isItAHeader='true'
        desc1='Computer Science Graduate'
        desc2= 'MNNIT ALLAHABAD'
        desc3 = 'Class of 2020'
        imageType='profile'
        />
      </header>
      <header className="App-header" style={{'background': '#cc0000'}}>
         <AboutMeRightHeader
         title='Technical stuffs that I like'
         desc1='Android App Development'
         desc2 = 'Web Development'
         desc3='coding / Programming'
         imageType='technical'
         />
      </header>
      <header className="App-header" style={{'background': '#000000'}}>
         <AboutMeHeader
         title='Projects'
         desc1='Daily Spend'
         desc2='Password saver App'
         desc3='Help Me android App'
         desc4='Lend and Borrow'
         desc5='Women Safe Android App'
         imageType='project'
         />
      </header>
      <header className="App-header" style={{'background': '#003300'}}>
         <AboutMeRightHeader
         title='Things I Love '
         desc1='Playing guitar'
         desc2 = 'Playing Video games/mobile games'
         desc3='Drawing and Painting'
         sectionType='hobby'
         /> 
      </header>

      <Footer/>
        </div>
    );
}

export default PortfolioHome;